import React, { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export const SaveFavoriteButton = ({ clause, model, modelLabel, onSaved }) => {
  const [open, setOpen] = useState(false);
  const save = async (scope) => {
    try {
      const r = await api.post("/lease-clauses/favorites", { title: clause.title, text: clause.text, model: scope, source_key: clause.key });
      toast.success("Clause ajoutée à vos favoris");
      onSaved(r.data, clause.key);
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    setOpen(false);
  };
  return (
    <span className="relative">
      <button type="button" title="Enregistrer dans mes clauses favorites" onClick={() => setOpen(!open)} className="text-brand-green/40 hover:text-amber-500" data-testid={`clause-fav-${clause.key}`}><Star className="w-4 h-4" /></button>
      {open && (
        <div className="absolute right-0 top-6 z-20 w-56 bg-white border border-brand-soft rounded-xl shadow-lg p-2 space-y-1" data-testid={`clause-fav-menu-${clause.key}`}>
          <p className="text-[11px] text-brand-green/50 px-2">Ajouter d'office sur :</p>
          {model && <button type="button" onClick={() => save(model)} className="w-full text-left px-2 py-1.5 rounded-lg text-sm hover:bg-brand-softer" data-testid={`clause-fav-model-${clause.key}`}>Les baux « {modelLabel} »</button>}
          <button type="button" onClick={() => save("")} className="w-full text-left px-2 py-1.5 rounded-lg text-sm hover:bg-brand-softer" data-testid={`clause-fav-all-${clause.key}`}>Tous les baux</button>
        </div>
      )}
    </span>
  );
};
